module.exports = __webpack_public_path__ + "img/bolsius_vit.b5517d39.svg";